import { Button, LoadingSpinner } from '@idexx-laboratories/spot-react';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import Grid from '../../components/Grid/Grid';
import { useStore } from '../../hooks/use-store';
import './RolesManagement.scss';

const RolesManagement = observer(() => {
  const { rolesManagementStore: store, globalStore } = useStore();
  const { loaders, rolesFiltered, sorting } = store;
  const navigate = useNavigate();

  useEffect(() => {
    void store.init();
    return () => {
      store.close();
    };
  }, [navigate, store]);

  if (loaders.page) return <LoadingSpinner size='large' />;

  return (
    <div className='roles-management-wrapper'>
      <div className='spot-typography__heading--level-2'>Roles</div>
      <div className='roles-management-table'>
        <Grid
          id='roles-management-grid'
          loading={globalStore.isLoading}
          disabled={globalStore.isLoading}
          columns={store.colDefs}
          data={rolesFiltered}
          sorting={sorting}
          noRowsText='No data'
          rowIdField='name'
        />
      </div>
      <div className='page-bottom-actions'>
        <Button className='back' variant='link' size='small' onClick={() => void navigate(-1)}>
          Back
        </Button>
        <div className='main-buttons'>
          <Button variant='primary' size='small' onClick={() => void navigate('/')}>
            Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
});

export default RolesManagement;
